import { useEffect, useState } from 'react';

/*
    Below 768px (Angular isMobile). Use it only for behavior that CSS cannot express. Use Tailwind
    breakpoints for layout.
*/

const MOBILE_QUERY = '(max-width: 767px)';

/*
    The Angular xsOrSm flag, which is `$window.innerWidth < 992` in is_mobile.js. It is a different
    threshold from isMobile and it drove one decision: collapsing the exam schedule behind VIEW
    SCHEDULE once the exam had started. It also matches Tailwind's md in this config, which is 992px,
    so the box's md:hidden class and this query agree.
*/
const BELOW_MD_QUERY = '(max-width: 991px)';

function useMatchesQuery(query: string) {
    const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

    useEffect(() => {
        const mediaQuery = window.matchMedia(query);
        const listener = (event: MediaQueryListEvent) => setMatches(event.matches);

        mediaQuery.addEventListener('change', listener);
        setMatches(mediaQuery.matches);

        return () => mediaQuery.removeEventListener('change', listener);
    }, [query]);

    return matches;
}

export function useIsMobileViewport() {
    return useMatchesQuery(MOBILE_QUERY);
}

export function useIsBelowMdViewport() {
    return useMatchesQuery(BELOW_MD_QUERY);
}
